import { faSearch } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { Col, Container, Form, InputGroup, Row } from "react-bootstrap";
import "./search.scss";

import { debounce, isEmpty, set } from "lodash";
import { faChevronRight, faHistory, faTimes } from "@fortawesome/pro-solid-svg-icons";
import { useDispatch } from "react-redux";
import { setSelectedSecurity } from "../../stores/security";
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from "react-i18next";

// Maximum number of recent searches to store
const MAX_RECENT_SEARCHES = 5;

const MainSearch = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const [blurTimeout, setBlurTimeout] = useState(null);
  const [searchValue, setSearchValue] = useState("");
  const [searchResult, setSearchResult] = useState([]);
  // const [searchPopularResult, setSearchPopularResult] = useState([]);
  // const [searchResultLoading, setSearchResultLoading] = useState(false);
  // const [searchResultError, setSearchResultError] = useState(false);
  const [searchResultContainer, setSearchResultContainer] = useState(false);
  const [isEmptyResult, setIsEmptyResult] = useState(false);
  const searchResultsRef = useRef([]);
  const searchResultContainerRef = useRef(null);
  const searchResultRowsRef = useRef(null);
  const [recentSearches, setRecentSearches] = useState([]);
  const [showRecentSearches, setShowRecentSearches] = useState(false);

  const [selectedResultIndex, setSelectedResultIndex] = useState(-1); // Seçili sonuç için yeni state

  // Load recent searches from localStorage on component mount
  useEffect(() => {
    const storedSearches = localStorage.getItem('recentSearches');
    if (storedSearches) {
      try {
        setRecentSearches(JSON.parse(storedSearches));
      } catch (e) {
        console.error('Error parsing recent searches from localStorage', e);
        localStorage.removeItem('recentSearches');
      }
    }
  }, []);

  // Function to add a search to recent searches
  const addToRecentSearches = (item) => {
    const searchItem = {
      document: { ...item.document },
      timestamp: new Date().getTime()
    };
    
    setRecentSearches(prevSearches => {
      // Filter out any existing search with the same code
      const filteredSearches = prevSearches.filter(
        search => search.document.code !== searchItem.document.code
      );
      
      // Add new search at the beginning and limit to MAX_RECENT_SEARCHES
      const updatedSearches = [searchItem, ...filteredSearches].slice(0, MAX_RECENT_SEARCHES);
      
      // Save to localStorage
      localStorage.setItem('recentSearches', JSON.stringify(updatedSearches));
      
      return updatedSearches;
    });
  };

  // Function to clear a specific recent search
  const clearRecentSearch = (e, code) => {
    e.stopPropagation(); // Prevent triggering the parent click
    
    setRecentSearches(prevSearches => {
      const updatedSearches = prevSearches.filter(
        search => search.document.code !== code
      );
      
      localStorage.setItem('recentSearches', JSON.stringify(updatedSearches));
      return updatedSearches;
    });
  };

  // Function to clear all recent searches
  const clearAllRecentSearches = (e) => {
    e.stopPropagation(); // Prevent triggering the parent click
    
    setRecentSearches([]);
    localStorage.removeItem('recentSearches');
  };

  const handleKeyDown = useCallback(
    (event) => {
      let nextIndex;
      if (event.key === "ArrowDown") {
        if (selectedResultIndex >= searchResult.length - 1) {
          nextIndex = 0;
        } else {
          nextIndex = selectedResultIndex + 1;
        }
        setSelectedResultIndex(nextIndex);
        adjustScroll(nextIndex);
        event.preventDefault();
      } else if (event.key === "ArrowUp") {
        if (selectedResultIndex <= 0) {
          nextIndex = searchResult.length - 1;
        } else {
          nextIndex = selectedResultIndex - 1;
        }
        setSelectedResultIndex(nextIndex);
        adjustScroll(nextIndex);
        event.preventDefault();
      } else if (event.key === "Enter") {
        if (selectedResultIndex !== -1 && searchResult[selectedResultIndex]) {
          // Seçili satır için `handleRowClick` fonksiyonunu çağır
          handleRowClick(searchResult[selectedResultIndex]);
          event.preventDefault(); // Form gönderimini önle
        }
      }
    }, [searchResult.length, selectedResultIndex]);

  const adjustScroll = (index) => {
    const currentItem = searchResultsRef.current[index];
    if (currentItem && searchResultContainerRef.current) {
      const container = searchResultContainerRef.current;
      const containerResultRows = searchResultRowsRef.current;
      const containerTop = container.scrollTop;
      const containerBottom = containerTop + container.clientHeight;
      const elementTop = currentItem.offsetTop;
      const elementBottom = elementTop + currentItem.clientHeight;

      if (elementBottom > containerBottom) {
        // Seçili öğe görünüm alanının altında kalıyorsa, öğeyi görünür yapmak için aşağı doğru scroll yap
        containerResultRows.scrollTop = elementBottom - container.clientHeight;
      } else if (elementTop < containerTop) {
        // Seçili öğe görünüm alanının üstünde kalıyorsa, öğeyi görünür yapmak için yukarı doğru scroll yap
        containerResultRows.scrollTop = elementTop;
      }
    }
  };

  useEffect(() => {
    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [handleKeyDown]);

  // useEffect(() => {
  //   getPopularSearch();
  // }, []);

  // const getPopularSearch = () => {
  //   setSearchPopularResult(dummyPopularSearchArray);
  // };

  const fetchSearchResults = useCallback(
    debounce((query) => {
      if (!query) {
        setSearchResult([]);
        return;
      }
      console.log(query);

      setIsEmptyResult(false);

      // new Field("id", FieldType.String, true,false,true),
      // new Field("sourceId", FieldType.Int32, false),
      // new Field("dataId", FieldType.Int32, false),
      // new Field("objectId", FieldType.String, false),
      // new Field("uniqueCode", FieldType.String, false),
      // new Field("name", FieldType.String, false),
      // new Field("alternativeName", FieldType.String, false),
      // new Field("code", FieldType.String, false, true),
      // new Field("countryCode", FieldType.String, false, true, false),
      // new Field("visible", FieldType.Bool, false),
      // new Field("listed", FieldType.Bool, false),
      // new Field("elite", FieldType.Bool, false),
      // new Field("index", FieldType.Bool, false),
      // new Field("screenable", FieldType.Bool, false), bualnalarla sorgulayabilirsin

      const url = `https://api.rasyonet.com/service-hisselab-spotlight/collections/Hisselab.Symbols/documents/search?q=${query}&query_by=name,code&filter_by=visible:true&&listed:true&&class:Equity`;

      fetch(url, {
        method: "GET",
        headers: {
          "x-typesense-api-key": "masterKeyk8pX5hD0793d8YQC5aD1aEPd7VleSuGP",
        },
      })
        .then((response) => response.json())
        .then((data) => {
          console.log("fetchSearchResults:", data);
          setSearchResultContainer(true);
          setShowRecentSearches(false);

          if (data.hits == undefined || data.hits.length == 0) {
            setSearchResult([]);
            setIsEmptyResult(true);
            return;
          }
          setSearchResult(data.hits);
        })
        .catch((error) => {
          console.error("fetchSearchResults Error:", error);
          document.getElementById("dataContainer").innerHTML =
            "Bir hata oluştu: " + error;
        });
    }, 750),
    []
  );

  const handleChange = (event) => {
    const value = event.target.value;
    setSearchValue(value);
    // setSelectedResultIndex(-1);

    // Check if the value has sufficient length to trigger a search
    // This handles both typing and pasting scenarios
    if (value.length >= 3) {
      fetchSearchResults(value);
    } else if (value.length === 0) {
      // Show recent searches when the field is cleared
      if (recentSearches.length > 0) {
        setShowRecentSearches(true);
        setSearchResultContainer(true);
      } else {
        setSearchResultContainer(false);
      }
    }
  };

  const handleFocus = () => {
    try {
      // Show recent searches when the input is focused and is empty
      if (searchValue.length === 0 && recentSearches.length > 0) {
        setShowRecentSearches(true);
        setSearchResultContainer(true);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleBlur = () => {
    const timeout = setTimeout(() => {
      setSearchResultContainer(false);
      setShowRecentSearches(false);
    }, 300);
    setBlurTimeout(timeout);
  };

  const handleRowClick = (item) => {
    clearTimeout(blurTimeout);
    console.log("Seçilen satır:", item);

    dispatch(setSelectedSecurity(item.document));
    setSearchResultContainer(false);
    setShowRecentSearches(false);

    // Add the selected item to recent searches
    addToRecentSearches(item);

    // navigate(`/StockAnalysis/dividend/${item.document.code}`);


    const currentPath = location.pathname;
    if (currentPath.includes('StockAnalysis')) {
      const basePath = currentPath.substring(0, currentPath.lastIndexOf('/') + 1);
      const newPath = `${basePath}${item.document.code}`;
      navigate(newPath);
    }
    else {
      navigate(`/StockAnalysis/summary/${item.document.code}`);
    }



    setSearchValue("");
  };

  // Handle click on a recent search item
  const handleRecentSearchClick = (recentItem) => {
    handleRowClick({ document: recentItem.document });
  };

  const resultItemClass = (index) =>
    `resault-wrap ${index === selectedResultIndex ? "hovered" : ""}`;

  return (
    <div className="position-relative search-component">
      <InputGroup className="main-search-input-group mx-auto">
        <InputGroup.Text id="inputGroup-sizing-default">
          <FontAwesomeIcon icon={faSearch} />
        </InputGroup.Text>
        <Form.Control
          className="main-search-input"
          aria-label="Default"
          aria-describedby="inputGroup-sizing-default"
          placeholder={t('seachSymbolShare')}
          value={searchValue}
          onChange={(e) => handleChange(e)}
          onFocus={handleFocus}
          onBlur={handleBlur}
        />
      </InputGroup>
      {searchResultContainer && (
        <Container
          ref={searchResultContainerRef}
          className="searchResultContainer position-absolute"
        >
          {/* Show recent searches if needed */}
          {showRecentSearches && recentSearches.length > 0 && (
            <>
              <Row className="p-10 d-flex justify-content-between align-items-center border-bottom">
                <Col>
                  <div className="d-flex align-items-center">
                    <FontAwesomeIcon icon={faHistory} className="me-2" />
                    <span className="roboto-medium-14">{t('recentSearches') || 'Son Aramalar'}</span>
                  </div>
                </Col>
                <Col xs="auto">
                  <div 
                    className="roboto-regular-14 text-primary clear-all-button" 
                    onClick={clearAllRecentSearches}
                  >
                    {t('clearAll') || 'Tümünü Temizle'}
                  </div>
                </Col>
              </Row>

              <Row ref={searchResultRowsRef} className="searchResulRow">
                {recentSearches.map((item, index) => (
                  <div
                    ref={(el) => (searchResultsRef.current[index] = el)}
                    key={`recent-${item.document.code}-${index}`}
                    className="resault-wrap recent-search-item"
                    onClick={() => handleRecentSearchClick(item)}
                  >
                    <div className="sec-detail">
                      <div className="roboto-medium-16">
                        {item.document.name}
                      </div>
                      <div className="roboto-regular-14 symbol-text">
                        {item.document.code}
                      </div>
                    </div>
                    <div className="sec-source d-flex align-items-center">
                      <div className="roboto-regular-14 source-text d-flex align-items-center">
                        Borsa Istanbul
                        <FontAwesomeIcon 
                          icon={faTimes} 
                          className="clear-recent-search ms-2"
                          onClick={(e) => clearRecentSearch(e, item.document.code)}
                        />
                      </div>
                    </div>
                  </div>
                ))}
              </Row>
            </>
          )}

          {/* Search Results */}
          {!showRecentSearches && (
            <Row ref={searchResultRowsRef} className="searchResulRow">
              {true &&
                searchResult.map((item, index) => (
                  <div
                    ref={(el) => (searchResultsRef.current[index] = el)}
                    key={item.objectId + index}
                    className={resultItemClass(index)}
                    onClick={() => handleRowClick(item)}
                  >
                    <div className="sec-detail">
                      <div className="roboto-medium-16 ">
                        {item.document.name}{" "}
                      </div>
                      <div className="roboto-regular-14 symbol-text">
                        {item.document.code}{" "}
                      </div>
                    </div>
                    <div className="sec-source">
                      <div className="roboto-regular-14 source-text">
                        Borsa Istanbul
                      </div>
                    </div>
                  </div>
                ))}
              {isEmptyResult && (
                <div
                  style={{
                    padding: 25,
                    display: "flex",
                    height: "100%",
                    justifyContent: "center",
                    alignItems: "center",
                    flex: 1,
                  }}
                >
                  <div className="roboto-medium-16 " style={{}}>
                    {t('noSearchResults') || 'Sonuç Bulunamadı'}{" "}
                  </div>
                </div>
              )}
            </Row>
          )}
        </Container>
      )}
    </div>
  );
};

export default MainSearch;
